import { render } from "./CampaignMessage.vue?vue&type=template&id=15941d2e&ts=true"
import script from "./CampaignMessage.vue?vue&type=script&lang=ts"
export * from "./CampaignMessage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__